// R1 (audyt podwójnych zwrotów, decyzja właściciela 27.10.2026 12:51): oznaczenie „wysłano egzemplarz zastępczy”
// na zamówieniu i we wszystkich jego sprawach (szuflada sprawy, widok zamówienia, dymek, okno ponownej wysyłki).
// Czysta funkcja (bez DOM, bez importów) — backend: core/services/ponowna_wysylka.py `egzemplarz_zastepczy`.

export type EgzemplarzZastepczy = {
  wyslano_at?: string | null; kto?: string | null; zrodlo?: string; przesylka?: string; w_toku?: boolean; opis?: string;
} | null | undefined;

const _esc = (s: unknown): string => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
  ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } as Record<string, string>)[c]);

/** „27.10.2026” z ISO (bez strefy czasu przeglądarki w testach — tylko data). */
export function dataKrotka(iso: unknown): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
}

/** Jedno zdanie oznaczenia: „Wysłano egzemplarz zastępczy 21.09.2026 · Paweł Pak · przesyłka INP9”. */
export function tekstOznaczenia(e: EgzemplarzZastepczy): string {
  if (!e || e.w_toku) return '';
  const cz = ['Wysłano egzemplarz zastępczy' + (e.wyslano_at ? ' ' + dataKrotka(e.wyslano_at) : '')];
  if (e.kto) cz.push(String(e.kto));
  if (e.przesylka) cz.push('przesyłka ' + String(e.przesylka));
  cz.push(e.zrodlo === 'krok_c1' ? 'krok „Ponowna wysyłka”' : 'druga przesyłka po reklamacji');
  return cz.join(' · ');
}

/** Baner (klasa podana przez miejsce osadzenia). Pusty, gdy oznaczenia nie ma albo krok C1 dopiero w toku. */
export function htmlOznaczeniaEgzemplarza(e: EgzemplarzZastepczy, klasa = 'egz-zastepczy'): string {
  const t = tekstOznaczenia(e);
  if (!t) return '';
  return '<div class="' + _esc(klasa) + '" data-egzemplarz-zastepczy="1" style="margin:6px 0;padding:8px 10px;border-radius:6px;'
    + 'border-left:3px solid #f59e0b;background:rgba(245,158,11,.12);font-size:12px;color:var(--color-text)">'
    + '<b>' + _esc(t) + '.</b> Przed zwrotem pieniędzy najpierw poproś klienta o odesłanie egzemplarza zastępczego.</div>';
}
